/**
 * Marks a route param as optional (`:tab` -> `:tab?`), so one route pattern matches
 * both `/sites/:id` and `/sites/:id/:tab`.
 *
 * Lives in its own module - importing it must not drag in the `src/utils/routing`
 * barrel, which reaches `src/graphql` and cannot be loaded from a unit test.
 */
export const optionalRouteParam = (paramPath: string) => `${paramPath}?`;
